"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCategory = exports.updateCategory = exports.addCategory = exports.fetchCategoriesIfNeeded = exports.DELETE_CATEGORY = exports.UPDATE_CATEGORY = exports.ADD_CATEGORY = exports.FETCH_CATEGORIES = void 0;
var utils_1 = require("../../utils");
exports.FETCH_CATEGORIES = (0, utils_1.networkActionTypes)("FETCH_CATEGORIES");
exports.ADD_CATEGORY = (0, utils_1.networkActionTypes)("ADD_CATEGORY");
exports.UPDATE_CATEGORY = (0, utils_1.networkActionTypes)("UPDATE_CATEGORY");
exports.DELETE_CATEGORY = (0, utils_1.networkActionTypes)("DELETE_CATEGORY");
var fetchCategories = (0, utils_1.networkAction)(exports.FETCH_CATEGORIES, "/categories");
exports.fetchCategoriesIfNeeded = (0, utils_1.makeIfNeededAction)(fetchCategories, "categories");
var _check = function (state) { return !(state.categories.isFetching ||
    state.categories.isAdding ||
    state.categories.isUpdating ||
    state.categories.isDeleting); };
var addCategory = function (categoryID, categoryData, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (!_check(state))
            return;
        return dispatch((0, utils_1.networkAction)(exports.ADD_CATEGORY, "/categories/".concat(categoryID), "PUT")(categoryData, {}, accessToken));
    };
};
exports.addCategory = addCategory;
var updateCategory = function (categoryID, categoryData, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (!_check(state))
            return;
        return dispatch((0, utils_1.networkAction)(exports.UPDATE_CATEGORY, "/categories/".concat(categoryID), "PUT")(categoryData, {}, accessToken));
    };
};
exports.updateCategory = updateCategory;
var deleteCategory = function (categoryID, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (!_check(state))
            return;
        return dispatch((0, utils_1.networkAction)(exports.DELETE_CATEGORY, "/categories/".concat(categoryID), "DELETE")({}, { id: categoryID }, accessToken));
    };
};
exports.deleteCategory = deleteCategory;
